import * as React from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Placement } from 'react-bootstrap/esm/Overlay';
import BootstrapTooltip from 'react-bootstrap/esm/Tooltip';

import './Tooltip.scss';

interface Props {
  text?: string | React.ReactElement | null | React.ReactNode;
  placement?: Placement;
}

const Tooltip: React.FC<Props> = ({ text, children, placement = 'right' }) => {
  return (
    <OverlayTrigger placement={placement} overlay={<BootstrapTooltip id="button-tooltip">{text}</BootstrapTooltip>}>
      <span>{children}</span>
    </OverlayTrigger>
  );
};

export default Tooltip;
